import { connect } from 'react-redux';

import {
  checkDailyQuizStatus,
  setDailyQuiz,
  setDailyTimeOut,
} from '../actions/dailyQuizActions';
import Daily20QuizResults from '../components/Daily20Quiz/Daily20QuizResults';
import { getQuiz } from '../components/Daily20Quiz/daily20QuizSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  quiz: getQuiz(state),
});

const mapDispatchToProps = (dispatch) => ({
  setDailyQuiz: (quiz) => dispatch(setDailyQuiz(quiz)),
  checkDailyQuizStatus: () => dispatch(checkDailyQuizStatus()),
  verifyLoggedUser: () => verifyLoggedUser(),
  setDailyTimeOut: (value) => dispatch(setDailyTimeOut(value)),
});

const Daily20QuizResultsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Daily20QuizResults);

export default Daily20QuizResultsContainer;
